import { render, staticRenderFns } from "./PpeRegisterPerson.vue?vue&type=template&id=05950bfc&"
import script from "./PpeRegisterPerson.vue?vue&type=script&lang=js&"
export * from "./PpeRegisterPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports